/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


import Privacy from "../../Privacy/Privacy";
import PageContentContainer from "../../Container/PageContentContainer";

const PrivacyPage = () => {
  return (
    <PageContentContainer size={"tiny"} backgroundColor={"white"}>
      <Privacy />
    </PageContentContainer>
  );
};

export default PrivacyPage;
